export const email_Regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
export const mobileNumber_Regex = /^\+?[6-9][0-9]{9}$/;
export const landline_Regex = /^(?:\+91[-\s]?)?[0]?(?:\d{2,5}[-\s]?)?\d{7,8}$/;